import { createReducer } from 'redux-starter-kit';
import { SET_TOKEN } from './actions';
import { OrganizationType } from './types';

interface AuthState {
  organization: OrganizationType;
  token: null | string;
}
// TODO refactor when auth0 comes in
const INITIAL_STATE: AuthState = {
  organization: {
    name: 'test1'
  },
  token: null
};

export default createReducer(INITIAL_STATE, {
  [SET_TOKEN]: (state, action) => {
    state.token = action.payload;
  }
});
